<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-title">Blocked IPs</div>
      </md-card-header>

      <md-card-content>
        <div v-for="ip in blockedIps" style="line-height: 32px; vertical-align: middle">
          {{ip}}
          <md-button class="md-icon-button md-dense" @click="unblockIp(ip)">
            <md-icon>lock_open</md-icon>
          </md-button>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
  export default {
    name: "security",
    data() {
      return {
        blockedIps: []
      }
    },
    methods: {
      unblockIp(ip) {
        this.$store.api.rpcRequest('ublockIP', {
          ip: ip
        }, blockedIps => {
          this.blockedIps = blockedIps;
          this.loading = false;
        }, errorMessage => {
          this.loading = false;
        });
      }
    },
    created() {
      this.$store.api.rpcRequest('getBlockedIPs', {}, blockedIps => {
        this.blockedIps = blockedIps;
        this.loading = false;
      }, errorMessage => {
        this.loading = false;
      });
    }
  }
</script>

<style scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Security.vue